import { Router } from '@angular/router';
import { AcumaticaService } from '../../acumatica/acumatica.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AcumaticaLoginComponent } from '../../acumatica/acumatica-login/acumatica-login.component';

@Component({
  selector: 'app-home-login',
  templateUrl: './home-login.component.html',
  styleUrls: ['./home-login.component.css']
})
export class HomeLoginComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private acumatica: AcumaticaService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.acumatica.username) {
      this.router.navigate(['']);
    } else {
      const dialogRef = this.dialog.open(AcumaticaLoginComponent, {
        disableClose: true
      });
      dialogRef.componentInstance.LoggedIn.subscribe(() => {
        dialogRef.close();
        this.router.navigate(['']);
      });
    }
  }

}
